import { render, staticRenderFns } from "./version-controls.vue?vue&type=template&id=5d3c7793&scoped=true&"
import script from "./version-controls.vue?vue&type=script&lang=js&"
export * from "./version-controls.vue?vue&type=script&lang=js&"
import style0 from "./version-controls.vue?vue&type=style&index=0&id=5d3c7793&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3c7793",
  null
  
)

component.options.__file = "version-controls.vue"
export default component.exports